export default __webpack_public_path__ + "static/media/NQPHN-commissioned-services-map-icons_Alcohol and Other Drugs.71eaee97.png";